// extracted by mini-css-extract-plugin
module.exports = {"landing":"LandingSection_landing__yR3Kk","content":"LandingSection_content__1vkky"};